var routerActions = require('react-router-redux').routerActions;
var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var BodyPart = (function() {

    var _requestBodyPart = function(bodyPart) {
      return {
        type: constants.REQUEST_BODYPART
      };
    }

    var _receiveBodyPart = function(data) {
      return {
        type: constants.RECEIVE_BODYPART,
        data: data.bodypart[0],
        receivedAt: Date.now()
      };
    }

    var _fetchBodyPart = function(bodyPart) {
      return function (dispatch) {
        dispatch(_requestBodyPart());
        return api.get('/proxy/v1/bodyparts?friendlyurl=' + bodyPart).then(function (response) {
          return response;
        }).then(function (data) {
          return dispatch(_receiveBodyPart(data));
        }).catch(function(error){
          if(error.response){
            dispatch(commonActions.setGenericResponseError('', error.response));
          }else{
            dispatch(commonActions.setGenericError('', error.message));
          }
        });
      };
    }

    var _shouldFetchBodyPart = function(state, friendlyUrl) {
      var bodyPart = state.bodyPart;
      if (Object.keys(bodyPart).length === 0) {
        return true;
    } else if (bodyPart.items && bodyPart.items.friendlyUrl === friendlyUrl) {
        return false;
      } else {
        return true;
      }
    }

    var _fetchBodyPartIfNeeded = function(bodyPart) {
      return function(dispatch, getState) {
        if (_shouldFetchBodyPart(getState(), bodyPart)) {
          return dispatch(_fetchBodyPart(bodyPart))
        }
      }
    }

    const _setBodyPart = function (bodyPart) {
      return {
        type: constants.SET_BODY_PART,
        data: bodyPart,
      };
    };

    const _createBodyPartRequest = function () {
      return {
        type: constants.CREATE_BODY_PART_REQUEST,
      };
    };

    const _createBodyPartSuccess = function (data) {
      return {
        type: constants.CREATE_BODY_PART_SUCCESS,
        data: data.bodypart,
      };
    };

    const _createBodyPartError = function (error) {
      return {
        type: constants.CREATE_BODY_PART_ERROR,
        errors: error.data,
      };
    };

    const _updateBodyPartRequest = function () {
      return {
        type: constants.UPDATE_BODY_PART_REQUEST,
      };
    };

    const _updateBodyPartSuccess = function (data) {
      return {
        type: constants.UPDATE_BODY_PART_SUCCESS,
        data: data.bodypart,
      };
    };

    const _updateBodyPartError = function (error) {
      return {
        type: constants.UPDATE_BODY_PART_ERROR,
        errors: error.data,
      };
    };

    var _createBodyPart = function(bodyPart, token) {
      return function (dispatch) {
        dispatch(_createBodyPartRequest());
        api.post('/proxy/v1/bodyparts/', bodyPart, token)
        .then(function(data) {
          const { bodypart: { friendlyUrl = '' } } = data;
          const redirect = (friendlyUrl) ? `/education/bodyparts/${friendlyUrl}` : '/education/';
          dispatch(_createBodyPartSuccess(data));
          dispatch(routerActions.replace(redirect));
        })
        .catch(function(error) {
            if (error.response){
                dispatch(_createBodyPartError(error.response));
            } else {
                dispatch(commonActions.setGenericError('', error.message));
            }
        })
      };
    }

    var _updateBodyPart = function(bodyPart, token) {
      return function (dispatch) {
        const { id: bodyPartId } = bodyPart;
        dispatch(_updateBodyPartRequest());
        api.put(`/proxy/v1/bodyparts/${bodyPartId}`, bodyPart, token)
        .then(function(data) {
          const { bodypart: { friendlyUrl = '' } } = data;
          const redirect = (friendlyUrl) ? `/education/bodyparts/${friendlyUrl}` : '/education/';
          dispatch(_updateBodyPartSuccess(data));
          dispatch(routerActions.replace(redirect));
        })
        .catch(function(error) {
            if (error.response){
                dispatch(_updateBodyPartError(error.response));
            } else {
                dispatch(commonActions.setGenericError('', error.message));
            }
        })
      };
    }

    return {
        requestBodyPart: _requestBodyPart,
        receiveBodyPart: _receiveBodyPart,
        fetchBodyPart: _fetchBodyPart,
        shouldFetchBodyPart: _shouldFetchBodyPart,
        fetchBodyPartIfNeeded: _fetchBodyPartIfNeeded,
        setBodyPart: _setBodyPart,
        createBodyPart: _createBodyPart,
        updateBodyPart: _updateBodyPart
    }
})();

module.exports = BodyPart;



// WEBPACK FOOTER //
// ./src/common/modules/education/actions/bodyPart.js